<template>
  <de-layout-content :noPadding="true" class="deviceManage">
    <el-tabs v-model="activeTabKey" @tab-click="tabClick" class="grayTab flxTab">
      <el-tab-pane label="设备列表" name="tab1">
        <div class="device">
          <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="ant-advanced-search-form">
            <el-form-item label="设备名称" prop="deviceName">
              <el-input
                v-model="queryParams.deviceName"
                placeholder="请输入设备名称"
                clearable
                @change="$forceUpdate()"
                @keyup.enter.native="handleQuery"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button plain type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
              <el-button plain icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
              <el-button type="primary" class="el-icon-plus" @click="handleAdd"  v-if="userRole == 'ADMIN'"> 新增设备 </el-button>
            </el-form-item>
          </el-form>

          <el-table v-loading="loading" element-loading-text="加载中" :data="deviceList">
            <el-table-column label="显示设置" align="center" prop="userName" width="100">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="switchChange(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="设备名称" align="center" prop="deviceName"></el-table-column>
            <el-table-column label="设备图片" align="center" prop="deviceImg">
              <template slot-scope="scope">
                <el-image 
                  class="deviceImg"
                  :src="scope.row.deviceImg"
                  v-if="scope.row.deviceImg"
                  :preview-src-list="[scope.row.deviceImg]">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column label="设备分类" align="center" prop="typeName"></el-table-column>
            <el-table-column label="数据获取方式" align="center" prop="dataGet"></el-table-column>
            <el-table-column label="设备厂商" align="center" prop="companyName"></el-table-column>
            <el-table-column label="添加人" align="center" prop="createBy"></el-table-column>
            <el-table-column label="添加时间" align="center" prop="createTime">
              <template slot-scope="scope">
                {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="280">
              <template slot-scope="scope">
                <el-button size="small" plain type="primary" @click="handleDtl(scope.row)">数据字段</el-button>
                <el-button size="small" plain type="primary" @click="handleEdit(scope.row)" v-if="userRole == 'ADMIN'">编辑</el-button>
                <el-button size="small" plain type="danger" @click="handleDel(scope.row)" v-if="userRole == 'ADMIN'">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="_getList"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="客户授权" name="tab2" v-if="userRole == 'ADMIN'">
        <client-list/>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :title="fieldTitle" inline="true" :visible.sync="showDetail" width="750px" class="dataFieldDialog">
      <el-button type="primary" class="el-icon-plus mb10" @click="indexModalVisible = true" v-if="userRole == 'ADMIN'"> 选择指标 </el-button>
      <el-table v-loading="loading" element-loading-text="加载中" :data="fieldList" height="500">
        <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
        <el-table-column label="指标名称" align="center" prop="name"></el-table-column>
        <el-table-column label="指标类型" align="center" prop="type"></el-table-column>
        <el-table-column label="说明" align="center" prop="remark"></el-table-column>
      </el-table>
    </el-dialog>

    <index-modal :visible="indexModalVisible" @cancel="cancelIndexModal" :deviceParam="deviceParam" />

    <el-dialog title="新增设备" inline="true" :visible.sync="showAdd" width="960px" class="addDeviceDialog">
      <device-form :componentsType="componentsType" @submit="formSubmit" />
    </el-dialog>
  </de-layout-content>
</template>

<script>
import indexModal from "./indexModal.vue";
import ClientList from "./clientList.vue";
import DeviceForm from "./deviceForm.vue";
import { deviceListNew, fieldListDQ } from "@/api/dataset/dataset";
import * as API_Ques from "@/api/dataAccess/accessApi";
import uploadImg from "@/components/uploadImg/uploadImg.vue";
import moment from "moment";
export default {
  components: {
    // Topic
    ClientList,
    DeviceForm,
    indexModal,
    uploadImg
  },
  data() {
    return {
      deviceParam: {},
      activeTabKey: "tab1",
      form: {
        content: "",
      },
      searchValue: "",
      recordValue: "", //变更列表查询条件
      defaultProps: {
        children: "children",
        label: "label",
      },
      indexModalVisible: false, //指标弹窗标志
      userRole: null,
      dataType: {
        '1': 'API',
        '2': '数据库',
        '3': '蓝牙',
        '4': 'EXCEL/CSV',
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        // deviceName: ''
      },
      loading: false,
      total: 0,
      deviceList: [],
      fieldTitle: '',
      fieldList: [],
      showDetail: false,
      showAdd: false,
      componentsType: 'add'
    }
  },
  computed: {
    // currentNodeId() {
    //   return this.param?.id;
    // },
  },
  watch: {
    // searchValue(val) {
    //   this.$refs.tree.filter(val);
    // },
  },
  created() {
    this.userRole = (this.$store.state.user.roles.length && this.$store.state.user.roles[0].name) || "";
    this._getList()
  },
  methods: {
    moment,
    _getList() {
      deviceListNew({...this.queryParams}).then(res => {
        console.log(res);
        if(res) {
          this.deviceList = res.data.list
          this.total = res.data.total 
        }
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this._getList()
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields();
			this.handleQuery();
    },
    handleAdd() {
      // this.showAdd = true
      // this.componentsType = 'add'
      this.$router.push({
        name: 'deviceEdit'
      });
    },
    handleDtl(item) {
      this.deviceParam = item
      this.fieldTitle = `[ ${item.deviceName} ]数据字段`
      this.getDeviceFieldList()
    },
    switchChange(e){
      const params = {
        deviceId: e.deviceId,
        status: e.status,
      };
      API_Ques.deviceEnable(params).then((res) => {
        if (res.code == 200) {
          this.$message.success("状态修改成功");
          this._getList();
        }
      });
    },
    handleEdit(item) {
      // console.log(item);
      // this.showAdd = true
      // this.componentsType = 'edit'
      localStorage.setItem('deviceInfo',JSON.stringify(item))
      this.$router.push({
        name: 'deviceEdit',
        query: {
          id: item.deviceId
        }
      });
    },
    handleDel(item) {
      this.$confirm(`确认删除“${item.deviceName}”`, "操作确认", {
          confirmButtonText: this.$t('chart.confirm'),
          cancelButtonText: this.$t('chart.cancel'),
          type: 'warning'
        }).then(() => {
          this._deviceDel(item.deviceId)
        }).catch(() => {
        })
    },
    _deviceDel(deviceId) {
      API_Ques.deviceDel({ deviceId }).then(res => {
        console.log(res);
        this.$message({ message: "已删除", });
        this.handleQuery()
      })
    },

    // API_Ques

    // 数据字段列表
    getDeviceFieldList() {
      this.showDetail = true
      this.dataSource = []
      if(this.deviceParam.datasetTableId) {
        this.loading = true;
        fieldListDQ(this.deviceParam.datasetTableId)
        .then((res) => {
          this.loading = false;
          this.fieldList = res.data.quotaList;
        })
        .catch((err) => {
          this.loading = false;
        });
      }
    },
    // 关闭指标弹窗
    cancelIndexModal(e) {
      // console.log(e);
      this.indexModalVisible = false;
      if(e) {
        // 通过子组件专递过来的值，更改父组件的datasetTableId
        this.deviceParam.datasetTableId = e
        this.getDeviceFieldList();
      }
    },
    init() {

    },
    formSubmit() {
      this.showAdd = false
      this.handleQuery()
    }
  },
};
</script>

<style lang="less" scoped>
.device {
  // display: flex;
  height: 100%;
  .deviceImg {
    width: 60px;
    height: 60px;
  }
}

</style>
